export default __webpack_public_path__ + "static/media/resource-group-example-1-sv.8ef361d6.png";